// extracted by mini-css-extract-plugin
module.exports = {"pressLandingPage":"style_pressLandingPage__kExb4"};